export default "/images/vendor/flag-icon-css/flags/4x3/ag.svg?065714bdfc57feaef68fd5ed3608376c";